import { STATS } from "../lib/constants";
import { Counter, Reveal } from "./motion";

export default function Stats() {
  return (
    <section
      data-testid="stats-section"
      className="border-b border-slate-200 bg-white"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-2 divide-y divide-slate-200 px-5 lg:grid-cols-4 lg:divide-x lg:divide-y-0 lg:px-8">
        {STATS.map((s, i) => (
          <Reveal
            key={s.label}
            delay={i * 0.08}
            data-testid={`stat-${i}`}
            className="px-2 py-10 text-center lg:px-8 lg:py-14 lg:text-left"
          >
            <div className="overline mb-3 text-pv-orange">0{i + 1}</div>
            <div className="font-display text-5xl font-extrabold tracking-tighter text-pv-green lg:text-6xl">
              <Counter value={s.value} />
              <span className="text-pv-lime">{s.suffix}</span>
            </div>
            <div className="mt-2 text-sm text-slate-600">{s.label}</div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
